import React from 'react';
const painPoints = ['Domingo a la noche buscando ejercicios en YouTube que nunca se adaptan a tu grupo real.', 'Llegás al lunes con algo improvisado, sin progresión ni objetivo claro.', 'Tus ejercicios son siempre los mismos porque no tenés un banco de sesiones.', 'Tenés jugadores de distintos niveles y terminás entrenando solo para el promedio.', 'Llegás al fin de semana agotado y el ciclo de buscar y armar vuelve a empezar.'];
export function ProblemSection() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto text-center" data-id="element-178">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-179">
          Si sos profe de Baby Fútbol en Argentina,
          <br data-id="element-180" />
          <span className="text-[#00C853]" data-id="element-181">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-3 text-left mb-10" data-id="element-182">
          {painPoints.map((point, i) => <div key={i} className="flex items-center gap-3 bg-[#FF8A80]/10 border border-[#FF8A80]/30 rounded-xl p-3 sm:p-4" data-id="element-183">
              <span className="text-[#FF8A80] text-xl flex-shrink-0" data-id="element-184">❌</span>
              <p className="text-white text-sm sm:text-base font-medium leading-snug" data-id="element-185">
                {point}
              </p>
            </div>)}
        </div>

        <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-8" data-id="element-186">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00C853] to-transparent w-full" data-id="element-187" />
      </div>
    </section>;
}